@if (isMenu) {
  <button mat-menu-item aria-label="Move">
    <mat-icon>folder_open</mat-icon>
    {{ 'moveToFolder' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    aria-label="Move"
    matTooltip="{{ 'moveToFolder' | translate }}">
    <i class="far fa-folder fa-xs"></i>
  </button>
}
